import { useSyncExternalStore } from "react";
import { getSession, type Session, subscribeSession } from "../api/session";

export function useSession(): Session | null {
  return useSyncExternalStore(subscribeSession, getSession, getSession);
}
